<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <navigation></navigation>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('manage')}}</h6>
                                <h1 class="header-title">{{$t('Bundles')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'bundleModal', model:{}})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <!-- Search -->
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-search text-muted"></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- / .row -->
                            </div>
                            <simple-table
                                :data="bundles"
                                :loading="areBundlesLoading"
                                :edit="edit"
                                :deleteItem="deleteItem"
                                :columns="columns"
                                :sort="sort"
                            ></simple-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bundle-modal id="bundleModal" :data="model"></bundle-modal>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';
import Navigation from './Navigation.vue'
import currency from '@/filters/currency.js';
import BundleModal from './BundleModal.vue';

export default {
    props: ['serviceId'],
    mixins: [modalMixins],
    // filters: [currency],
    components: {
        BundleModal,
        Navigation,
        SimpleTable,
    },
    data() {
        return {
            query: null,
            model: {},
            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            items: [],
            areItemsLoading: false,
            columns: [
                {
                    label: '',
                    name: 'public',
                    width: '1px',
                    field(item) {
                        if (item.public)
                            return '<i class="fe fe-check"></i>'

                    }
                },
                {
                    label: 'Code',
                    name: 'code',

                },
                {
                    label: 'Name',
                    name: 'label',
                    subtitle: (item) => {
                        return item.service.label;
                    },
                },
                {
                    label: 'Price',
                    name: 'price',
                    field: (item) => {
                        return currency(item.price, this.$settings.currency.text, 0, { spaceBetweenAmountAndSymbol: ' ', symbolOnLeft: false });
                    }
                },
                {
                    label: 'Duration',
                    width: '100px',
                    name: 'duration',
                    field: (item) => {
                        return item.duration + this.$t('min');
                    },
                    subtitle: (item) => {
                        return item.bufferDuration + this.$t('min');
                    },
                },


            ],
            sort: '',

        }
    },
    computed: {

        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
        ...mapGetters('bundle', { findBundlesInStore: 'find' }),
        ...mapState('bundle', { areBundlesLoading: 'isFindPending' }),

        services() {
            return this.findServicesInStore({ query: { $sort: { priority: 1 } } }).data;
        },
        treatments() {
            return this.findTreatmentInStore().data;
        },
        bundles() {
            return this.findBundlesInStore(this.params).data;
        }
    },
    created() {

    },
    watch: {
        query: debounce(function (newVal) {
            this.queryBundles();
        }, 400),
        serviceId: debounce(function (newVal) {
            this.queryBundles();
        }, 400),
    },
    methods: {
        ...mapActions('bundle', ['find', 'remove', 'create', 'patch']),
        // ...mapActions('service', ['find', 'remove', 'create', 'patch']),
        // ...mapActions('treatment', { findTreatments: 'find', deleteTreatment: 'remove' }),

        edit(item) {
            this.openModal({ id: 'treatmentModal', model: item });
        },
        deleteItem(item) {
            this.deleteTreatment(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Treatment has been deleted')
                });
            })
        },
        queryBundles() {

            if (this.query) {
                this.params.query.$or = [
                    { label: { $regex: this.query, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }

            if (this.serviceId) {
                this.params.query.serviceId = this.serviceId;
            } else {
                delete this.params.query.serviceId;
            }
            this.find(this.params);
        },

    }
}
</script>
